/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import ExGrid from "../../shared/Grid/ExGrid";
import ExColumn from "../../shared/Grid/ExColumn";
import FormInputNumber from "../../shared/forms/FormFields/FormInputNumber";
import FormClipboardImage from "../../shared/forms/FormFields/FormClipboardImage";
import FormTextArea from "../../shared/forms/FormFields/FormTextArea";
import DeleteButton from "../../shared/Grid/Buttons/DeleteButton";
import * as numeral from "numeral";
import _ from "lodash";
const GastosMovimientoPorComprobar = ({
  value: gastos = [],
  onChange,
  onValidate,
  formDisabled,
}) => {
  const handleComprobantesChange = (comprobantes, editIndex) => {
    onChange(
      gastos.map((gasto, index) => {
        if (editIndex !== index) {
          return gasto;
        }

        const montoComprobado = _.sumBy(comprobantes, (x) =>
          Number(x?.monto ?? 0)
        );

        return {
          ...gasto,
          comprobado: montoComprobado,
          montoComprobado,
          comprobantes,
        };
      })
    );
  };
  const getMontoSolicitado = (gasto) => {
    return gasto?.montoSolicitado ?? gasto?.monto ?? 0;
  };

  const getMontoComprobado = (gasto) => {
    return gasto?.montoComprobado ?? gasto?.comprobado ?? 0;
  };

  return (
    <div className="gastos"  style={{ width: "100%", minWidth: "100%",  display: "grid", gridTemplateColumns: "1fr 1fr"  }}>
      <div className="grid-header"></div>
      <div className="grid-header">MONTO A COMPROBAR</div>
      <div className="grid-header" />
      <div className="grid-header" />

      {gastos?.map((gasto, index) => {
        const comprobantes = gasto?.comprobantes ?? [];

        return (
          <React.Fragment key={index}>     

            <div className="cell-gasto">
              <span>
                <span>
                  {numeral(getMontoSolicitado(gasto)).format("$0,0.00")}
                </span>{" "}
                /
                <span className="bold">
                  {numeral(getMontoComprobado(gasto)).format("$0,0.00")}
                </span>
              </span>
            </div>

            <div className="cell-gasto" style={{   display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              <ButtonIcon
                title="Agregar"
                iconName="SiAddthis"               
                onClick={() =>
                  handleComprobantesChange([...comprobantes, {}], index)
                }
              />
            </div>

            <div
              style={{ gridColumnEnd: "span 4" }}
              className={`cell-gasto ${gasto.collapsed ? "collapsed" : ""}`}
            >
              <ExGrid
                visibleHeader={false}
                data={comprobantes}
                onChange={(rows) => handleComprobantesChange(rows, index)}
                getEntityId={(row) =>
                  row.id ?? row.comprobanteId ?? row._uniqueUid
                }
                onValidate={onValidate}
                formDisabled={formDisabled}
              >
                <ExColumn
                  field="descripcion"
                  width="4fr"
                  maxLength={4000}
                  rows={3}
                  required={true}
                  cellRenderer={(props) => (
                    <FormTextArea {...props} width="100%" />
                  )}
                />

                <ExColumn
                  field="monto"
                  width="2fr"
                  cellRenderer={FormInputNumber}
                  maxFractionDigits={2}
                  required={true}
                />

                <ExColumn
                  field="comprobante"
                  width="100px"
                  cellRenderer={(props) => (
                    <FormClipboardImage
                      {...props}
                      required={gasto.comprobanteRequerido ?? true}
                    />
                  )}
                />

                <ExColumn
                  field="eliminar"
                  width="40px"
                  cellRenderer={DeleteButton}
                />
              </ExGrid>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default GastosMovimientoPorComprobar;